import apiEndpoints from '../../const/apiEndpoints'
import api from '../../services'
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  GetQuestionPapersPayload,
  GetQuestionPapersResponse,
  GetQuestionPaperTopics
} from './types'

export const getQuestionPaperTopics = createAsyncThunk(
  'createTest/getQuestionPaperTopics',
  async ({
    courseId,
    subjectId,
    chapterId
  }: GetQuestionPaperTopics): Promise<Array<string>> => {
    const response = await api.get(
      `${apiEndpoints.getQuestionPaperTopics}?courseId=${courseId}&subjectId=${subjectId}&chapterId=${chapterId}`
    )
    return response?.data
  }
)

export const getQuestionPapers = createAsyncThunk(
  'createTest/getQuestionPapers',
  async ({
    pageNumber,
    pageSizeNumber,
    sortBy,
    ascDesc,
    searchCriteria = {}
  }: GetQuestionPapersPayload): Promise<GetQuestionPapersResponse> => {
    const requestPayload = {
      pageNo: pageNumber,
      pageSize: pageSizeNumber,
      sortBy: sortBy,
      ascDesc: ascDesc,
      searchCriteria
    }
    const response = await api.post(
      apiEndpoints.getQuestionPapers,
      requestPayload
    )
    return {
      questionBank: response?.data?.content,
      pageSize: response?.data?.totalPages,
      currentPage: response?.data?.number
    }
  }
)
export const fetchBulkQuestions = createAsyncThunk(
  'createTest/fetchBulkQuestions',
  async (questionPaperUploadId: string): Promise<Array<string>> => {
    const response = await api.post(
      `${apiEndpoints.fetchBulkQuestions}?questionPaperUploadId=${questionPaperUploadId}`
    )
    return response?.data
  }
)

export const createTest = createAsyncThunk(
  'createTest/createTest',
  async (data: any, { dispatch }): Promise<string> => {
    const response = await api.post(apiEndpoints.createTest, data)

    if (response.data) {
      dispatch(fetchBulkQuestions(response.data?.data))
    }
    return response.data
  }
)
